export const PAGE_TYPE = {
  HOME: 'home',
  SEARCH: 'search',
  SEARCH_MORE: 'search_more',
  ARTIST: 'artist',
  ARTIST_VIEW_ALL: 'artist_view_all',
  REVIEWS_MAIN: 'reviews_main',
  REVIEWS_POST: 'reviews_post',
  REVIEWS_USERREVIEWS: 'reviews_userreviews',
  REVIEWS_DETAIL: 'reviews_detail',
  NEWS_MAIN: 'news_main',
  NEWS_POST: 'news_post',
  LISTS_MAIN: 'lists_main',
  LIST_POST: 'list_post',
  NOTICE_MAIN: 'notice_main',
  NOTICE_POST: 'notice_post',
  MYPAGE: 'mypage',
  NOTIFICATION: 'notification',
};

export const CONTENT_TYPE = {
  ALBUM: 'album',
  REVIEW: 'review',
  COMMENT: 'comment',
  NEWS: 'news',
  LIST: 'list',
  LIST_SONG: 'list_song',
  LIST_ALBUM: 'list_album',
  NOTICE: 'notice',
  ARTIST: 'artist',
  USER_PROFILE: 'user_profile',
};

export const REFERRER_TYPE = {
  MENU: 'menu',
  SEARCH: 'search',
  EXTERNAL: 'external',
  BANNER: 'banner',
  NOTIFICATION: 'notification',
  MYPAGE: 'mypage',
  HOME: 'home',
  DIRECT: 'direct',
};

export const ARTIST_SECTION = {
  FULL_ALBUMS: 'full_albums',
  SINGLES: 'singles',
  LIVE_ALBUMS: 'live_albums',
  COMPILATION_ALBUMS: 'compilation_albums',
  APPEARS_ON: 'appears_on',
  SIMILAR_ARTISTS: 'similar_artists',
};

export const ARTIST_ACTION_TYPE = {
  ALBUM_CLICK: 'album_click',
  VIEW_ALL: 'view_all',
  ARTIST_CLICK: 'artist_click',
};

export const LIST_ACTION_TYPE = {
  ALBUM_CLICK: 'album_click',
  ARTIST_CLICK: 'artist_click',
};

export const REVIEW_SECTION = {
  ISSUES: 'issues',
  RECOMMENDED_ALBUM: 'recommended_album',
  USER_REVIEWS: 'user_reviews',
};

export const HOME_SECTION = {
  FEATURED: 'featured',
  RECOMMENDED: 'recommended',
  KOREAN_MUSIC: 'korean_music',
  GLOBAL_MUSIC: 'global_music',
  LATEST_REVIEWS: 'latest_reviews',
  NEWS: 'news',
  LISTS: 'lists',
};

export const EXTERNAL_LINK_TYPE = {
  APPLE_MUSIC: 'apple_music',
  SPOTIFY: 'spotify',
  NEWS_SOURCE: 'news_source',
  CRITIC_REVIEW: 'critic_review',
};
